module.exports = __webpack_public_path__ + "static/media/google-play.0a10932b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/google-play.webp
// module id = 296
// module chunks = 0